import { useEffect, useState } from "react";
import { toast } from "sonner";
import { LogIn, LogOut } from "lucide-react";
import { api, formatErr } from "../lib/api";
import { fmtTime } from "../lib/format";
import { Button } from "./ui/button";

export const CheckInWidget = ({ onChange }) => {
  const [rec, setRec] = useState(undefined);
  const [now, setNow] = useState(new Date());
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/attendance/today").then((r) => setRec(r.data));
  useEffect(() => {
    load();
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const act = async (kind) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/attendance/${kind}`);
      setRec(data);
      toast.success(kind === "check-in" ? "Checked in. Have a great day!" : "Checked out. See you tomorrow!");
      onChange?.();
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-2xl bg-[#0A0807] text-white p-6 relative overflow-hidden" data-testid="checkin-widget">
      <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#E08A1E]/20 blur-3xl" />
      <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#E08A1E]">Today</div>
      <div className="text-4xl font-extrabold tracking-tight mt-2 tabular-nums" data-testid="live-clock">
        {now.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
      </div>
      <div className="text-sm text-neutral-400">{now.toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long" })}</div>
      <div className="grid grid-cols-2 gap-3 mt-5 text-sm">
        <div><div className="text-neutral-500 text-xs">Check-in</div><div className="font-semibold" data-testid="checkin-time">{fmtTime(rec?.check_in)}</div></div>
        <div><div className="text-neutral-500 text-xs">Check-out</div><div className="font-semibold" data-testid="checkout-time">{fmtTime(rec?.check_out)}</div></div>
      </div>
      <div className="mt-5 relative">
        {rec === undefined ? null : !rec ? (
          <Button disabled={busy} onClick={() => act("check-in")} data-testid="check-in-button" className="w-full bg-[#E08A1E] hover:bg-[#C87515] text-white rounded-full">
            <LogIn className="h-4 w-4 mr-2" /> Check in
          </Button>
        ) : !rec.check_out ? (
          <Button disabled={busy} onClick={() => act("check-out")} data-testid="check-out-button" className="w-full bg-white text-[#0A0807] hover:bg-neutral-200 rounded-full">
            <LogOut className="h-4 w-4 mr-2" /> Check out
          </Button>
        ) : (
          <div className="text-sm text-neutral-300" data-testid="day-complete">Day complete · {rec.hours} hrs logged</div>
        )}
      </div>
    </div>
  );
};
